/// <reference path="../../../Scripts/Public/jquery-1.6.2.min.js" />
/// <reference path="../../General.js" />
/// <reference path="../../SumoDataAccess.js" />
/// <reference path="../../SumoClass.js" />
/// <reference path="../ControlBase.js" />

if (isNullOrUndefined(sumo)) {
    throw ('Paginator.js requies the sumo namespace defined in SumoClass.js');
}

if (isNullOrUndefined(sumo.controls)) {
    throw ('Paginator.js requies the sumo.controls namespace defined in ControlBase.js');
}
/**
 * @class 
 * sumo.controls.Wizard
 * Create amazing Wizards with Sumo Wizard component.
 * @param  {} aId
 * @param  {} aParentId
 * @param  {} aOptions
 * 
 * @example
 * mEnrolleesControls.DeviceAssignmentsWizard = new sumo.controls.Wizard('uDeviceAssignmentsWizard', 'uWizardHolder', {
        'steps': [
            { 'fileName': 'Interface/Enrollees.Offenders.Profile.Assignments.Wizard/Tracking.html', 'allowSave': true, 'hidden': false, 'pageTitle': 1 },
            { 'fileName': 'Interface/Enrollees.Offenders.Profile.Assignments.Wizard/Station.html', 'allowSave': true, 'hidden': false, 'pageTitle': 2 },
            { 'fileName': 'Interface/Enrollees.Offenders.Profile.Assignments.Wizard/Configuration.html', 'allowSave': true, 'hidden': false, 'pageTitle': 3 }],
        'FixPages': { 'UseSkip': false, 'AddOne': 2, 'SubtractOne': 4 },
        'HidablePage': 3

    });
 */
sumo.controls.Wizard = function (aId, aParentId, aOptions) {
    "use strict";
    var mThis = this,
        mId = aId,
        mParentId = aParentId,
        mOptions = aOptions,
        mCurrentStep = 0,
        mAddOne = false,
        mTable = null,
        mHtml = [],
        mControl;

    function initialize() {
        mHtml.push('<div class="sumo-wizard-control" id="##id##">');
        mHtml.push('</div>');
    }
    initialize();

    sumo.controls.Paginator.prototype.baseClass.call(this, aId, aParentId, mHtml.join(''), aOptions);

    if (this.isNothing(this.Options)) {
        throw (this.className() + ': invalid call to constructor. no params passed to control id: ' + this.Id);
    }

    this.dispose = function () {
        $('#' + aParentId).html('');
        mControl = null;
    };

    function fixPageCount() {
        "use strict";
        var lIndex = 0,
            lStep,
            lKey;

        for (lKey in mOptions.steps) {
            if (mOptions.steps.hasOwnProperty(lKey)) {
                ++lIndex;
                lStep = mOptions.steps[lKey];
                var pageSlide = $('td.sumo-wizard-blade.sumo-wizard-blade-command.sumo-wizard-blade-' + lIndex);
                if (mOptions.FixPages.UseSkip)
                    pageSlide[0].textContent = lStep.pageTitle;
                 else
                    pageSlide[0].textContent = lIndex;
            }
        }
    }
    this.FixPagesOnSelect = function (aValue, aPage) {
        mOptions.FixPages.UseSkip = aValue;
        mOptions.steps[aPage - 1].hidden = aValue;
        fixPageCount();
    }

    this.FixPageDisplay = function () {
        "use strict";
        var lIndex = 0,
            lStep,
            lKey;

        for (var lKey in mOptions.steps) {
            if (mOptions.steps.hasOwnProperty(lKey)) {
                ++lIndex;
                lStep = mOptions.steps[lKey];

                if (lIndex == mOptions.HidablePage) {
                    if (lStep.hidden) {
                        $('#' + mId + lIndex).hide();
                        $('.sumo-wizard-blade-' + lIndex).hide();
                    } else {
                        $('#' + mId + lIndex).show();
                        $('.sumo-wizard-blade-' + lIndex).show();
                    }
                }
            }
        }

    }

    function generateTable() {
        var lTableHtml = [],
            lContentHtml = [],
            lCommandHtml = [],
            lIndex = 0,
            lStep,
            lKey;

        for (lKey in mOptions.steps) {
            if (mOptions.steps.hasOwnProperty(lKey)) {
                ++lIndex;
                lStep = mOptions.steps[lKey];
                lContentHtml.push('<td class="sumo-wizard-blade-content sumo-wizard-content" id="');
                lContentHtml.push(mId);
                lContentHtml.push(lIndex);
                lContentHtml.push('Content"></td>');
                lContentHtml.push('<td class="sumo-wizard-blade sumo-wizard-blade-content sumo-wizard-blade-');
                lContentHtml.push(lIndex);
                lContentHtml.push('">');
                lContentHtml.push('</td>');
                lCommandHtml.push('<td class="sumo-wizard-blade-command sumo-wizard-content" id="');
                lCommandHtml.push(mId);
                lCommandHtml.push(lIndex);
                lCommandHtml.push('Command"></td>');
                lCommandHtml.push('<td class="sumo-wizard-blade sumo-wizard-blade-command sumo-wizard-blade-');
                lCommandHtml.push(lIndex);
                lCommandHtml.push('">');
                lCommandHtml.push(lStep.pageTitle.toString());
                lCommandHtml.push('</td>');
                
            }
        }

        lTableHtml.push('<table border="0" cellspacing="0" cellpadding="0">');
        lTableHtml.push('<tr>');
        lTableHtml.push(lContentHtml.join(''));
        lTableHtml.push('</tr>');
        lTableHtml.push('<tr>');
        lTableHtml.push(lCommandHtml.join(''));
        lTableHtml.push('</tr>');
        lTableHtml.push('</table>');
        return lTableHtml.join('');
    }

    function onPrevious() {
        var l = 0;
        if (mOptions.FixPages.UseSkip) {
            if (mOptions.FixPages.SubtractOne == mCurrentStep) {
                l = 1;
            }
        }
        setStep(mCurrentStep - 1 - l);
    }

    function onNext() {
        var l = 0;
        if (mOptions.FixPages.UseSkip) {
            if (mOptions.FixPages.AddOne == mCurrentStep) {
                l = 1;
            }
        }
        setStep(mCurrentStep + 1 + l);
    }

    function onClose() {
        mThis.trigger('close');        
    }

    function onSave() {
        mThis.trigger('changing', mCurrentStep);
        mThis.trigger('save', mCurrentStep);
        //mThis.trigger('close', mCurrentStep);
        //mThis.ParentElement.empty();
    }

    function window_OnChange() {
        var lControlHeight,
            lBladeHeight,
            lHeightOffset,
            lControlWidth,
            lBladeWidth,
            lWidthOffset;

        lControlHeight = mThis.ControlElement.height();
        lControlWidth = mThis.ControlElement.outerWidth();
        lBladeHeight = mTable.height();
        lBladeWidth = mTable.width();

        mThis.ControlElement.css('padding-top', ((lControlHeight - lBladeHeight) / 2).toString() + 'px');
        mThis.ControlElement.css('padding-left', ((lControlWidth - lBladeWidth) / 2).toString() + 'px');
    }

    function setStep(aStepIndex) {
        function onComplete() {
            var lStep = mOptions.steps[mCurrentStep - 1],
                lHtml = [];

            lHtml.push('<table style="width:100%;">');
            lHtml.push('<tr>');
            lHtml.push('<td style="width:33%;" align="left">');
            if (mCurrentStep > 1) {
                lHtml.push('<div class="sumo-wizard-previous" id="');
                lHtml.push(mId);
                lHtml.push(mCurrentStep);
                lHtml.push('Previous"></div>');
            }
            lHtml.push('</td>');
            lHtml.push('<td style="width:7%;" align="right">');
            lHtml.push('<div class="sumo-wizard-close" id="');
            lHtml.push(mId);
            lHtml.push('Close"></div>');
            lHtml.push('</td>');
            lHtml.push('<td style="width:7%;" align="center">');
            if (lStep.allowSave || mCurrentStep === mOptions.steps.length) {
                lHtml.push('<div class="sumo-wizard-save" id="');
                lHtml.push(mId);
                lHtml.push(mCurrentStep);
                lHtml.push('Save"></div>');
            }
            lHtml.push('</td>');
            lHtml.push('<td style="width:33%;" align="right">');
            if (mCurrentStep < mOptions.steps.length) {
                lHtml.push('<div class="sumo-wizard-next" id="');
                lHtml.push(mId);
                lHtml.push(mCurrentStep);
                lHtml.push('Next"></div>');
            }
            lHtml.push('</td>');
            lHtml.push('</tr>');
            lHtml.push('</table>');
            $('#' + mId.toString() + mCurrentStep.toString() + 'Command').html(lHtml.join(''));
            $('#' + mId.toString() + mCurrentStep.toString() + 'Previous').click(onPrevious);
            $('#' + mId.toString() + mCurrentStep.toString() + 'Next').click(onNext);
            $('#' + mId.toString() + mCurrentStep.toString() + 'Save').click(onSave);
            $('#' + mId.toString() + 'Close').click(onClose);
            mThis.trigger('changed', mCurrentStep);
            window_OnChange();
        }

        mThis.trigger('changing', mCurrentStep);
        $('.sumo-wizard-content').empty();
        $('.sumo-wizard-content-active').removeClass('sumo-wizard-content-active');
        mCurrentStep = aStepIndex;
        var lStep = mOptions.steps[mCurrentStep - 1];

        $('.sumo-wizard-blade').show();
        $('.sumo-wizard-blade-' + mCurrentStep).hide();
        if (mOptions.FixPages.UseSkip && (mCurrentStep + 1 == mOptions.HidablePage || mCurrentStep - 1 == mOptions.HidablePage))
            $('.sumo-wizard-blade-' + mOptions.HidablePage).hide();

        $('#' + mId.toString() + mCurrentStep.toString() + 'Content').addClass('sumo-wizard-content-active').load(lStep.fileName, onComplete);
    }

    this.close = function () {
        mThis.trigger('close', mCurrentStep);
        mThis.ParentElement.empty();
    };

    this.render = function () {
        var lHtml = generateTable();

        mThis.ControlElement.html(lHtml);
        mTable = mThis.ControlElement.find('table');
        $(window).change(window_OnChange).change();
        setStep(1);
        mThis.FixPageDisplay();
    };
    this.render();

};
sumo.controls.Paginator.prototype = new sumo.controls.ControlBase();
sumo.controls.Paginator.prototype.constructor = sumo.controls.Paginator;
sumo.controls.Paginator.prototype.baseClass = sumo.controls.ControlBase;